import type {CSSProperties} from 'react';
import {font} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeOnboardAreaVariant = 'wedge-onboard-area';

export const isWedgeOnboardAreaVariant = (variant: unknown): variant is WedgeOnboardAreaVariant => variant === 'wedge-onboard-area';

/* The about-you textarea of the onboarding identity step: one bare native textarea. It is the large onboarding field
   (`wedge-onboard-field`) with the multi-line values of the source: 14px of padding, 16px regular type, a 1.5 line height, no
   resize handle and a 130px floor. The ease and the colors read the exact legacy roles, so the shipped ink rules keep matching.
   `rows` stays with the caller. */
export function wedgeOnboardAreaStyle(_variant: WedgeOnboardAreaVariant): CSSProperties {
  const r = wedgeExactRole;
  return {
    width: '100%', padding: 14, background: r('bgElev'), border: `1px solid ${r('cardBorder')}`, borderRadius: 13, fontSize: font.headline,
    color: r('label'), fontFamily: r('font'), lineHeight: 1.5, resize: 'none', outline: 0, boxSizing: 'border-box', minHeight: 130,
    transition: `border-color 200ms ${r('ease')}, box-shadow 200ms ${r('ease')}`,
  };
}
